import { Component, OnInit, ViewChild, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ICustomerMoveInSettings } from '../models/CustomerModel';
import { CommonMethodService } from '../common-method.service';
import { ELOV_LimitOptions, EModuleType, EnumDiscount } from '../enum';
import { GeneralService } from 'src/app/services/general.service';
import { IFacPaymentSettingsDetails } from '../models/ProspectModel';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
@Component({
    selector: 'app-pricing-promotion',
    templateUrl: 'pricing-promotion.component.html',
    styleUrls: ['pricing-promotion.component.scss'],
    standalone: false
})
export class PricingPromotionSharedComponent implements OnInit {
    loaderIcon: Promise<boolean>;
    discountsCategorized = false;
    modifiedRecordsWithoutNotes = [];
    categorizedDiscList = {
        ApplicableDiscounts: [],
        ActiveDiscounts: [],
        ActiveAndStoppedDiscounts: []
    };
    @Input() moduleType: number;
    @Input() discountPrepaycheck;
    @Input() paymentSetting: IFacPaymentSettingsDetails;
    @Input() moveInSettings: ICustomerMoveInSettings;
    @Output() emitDiscountList = new EventEmitter();
    @Output() emitCancelDiscount = new EventEmitter();
    @Input() effectiveDatesList: Array<Date>;
    @Input() stopDatesList: Array<Date>;
    @Input() discountModalList = [];
    @Input() LatestURCToDatePlusOne;
    @Input() initialDiscountsList = [];
    @ViewChild('pricingPromotionPopup', { static: false }) pricingPromotionPopup: ModalDirective;

    constructor(private commotMethodService: CommonMethodService,
        private generalService: GeneralService,
        private modalWrapper: ModalWrapperService) { }

    ngOnInit() {
        if (this.moduleType === EModuleType.MakePayment) {
            this.openPricingAndPromotions();
        }

        this.generalService.stopLoaderEmitter.subscribe((event) => {
            this.loaderIcon = Promise.resolve(false);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.discountModalList) {
            this.openPricingAndPromotions();
        }
    }

    openPricingAndPromotions() {
        if (this.moduleType == EModuleType.ModifyRental) {
            if (this.pricingPromotionPopup && !this.pricingPromotionPopup.isShown) {
                this.modalWrapper.openDirective(this.pricingPromotionPopup);
            }
        }
        const userGroupLimits = this.generalService.UserPermissions.UserGroupOptionLimits.find(ele => ele.OptionId == ELOV_LimitOptions.AddionalPrePayPerid);
        const restrictPrepay = this.paymentSetting.RestrictPrepay && this.paymentSetting.RestrictedPrepayPeriod > 0;
        const userLimit = userGroupLimits ? userGroupLimits.Limit : 0;
        const restrictedPrepayPeriod = restrictPrepay ? this.paymentSetting.RestrictedPrepayPeriod : 0;
        const applyMultiDisc = this.moveInSettings.ApplyMultipleDisc;
        const singleDisc = this.discountModalList.find(ele => ele.Selected && (ele.ApplyDiscAutomatically && !ele.AllowToOverrideDisc));
        this.discountModalList.forEach((ele) => {
            ele['enableDisc'] = singleDisc && !applyMultiDisc ? ele.DiscountId === singleDisc.DiscountId : true;
            if (this.moduleType == EModuleType.ModifyRental) {
                if (ele.CategoryId == EnumDiscount.PrePayment) {
                    ele.Selected = false;
                    ele['enableDisc'] = false;
                } else {
                    if (!ele.Selected && ele.ApplyDiscAutomatically) {
                        ele.Selected = true;
                        ele['enableDisc'] = false;
                    }
                    if (ele.AllowToOverrideDisc) {
                        ele['enableDisc'] = true;
                    }
                }
            } else {
                if (ele.CategoryId == EnumDiscount.PrePayment) {
                    this.discountPrepaycheck = Math.max(ele.PrePayPeriod, ele.ApplyAfter + 1);
                    if ((userGroupLimits || this.paymentSetting.RestrictPrepay) && this.discountPrepaycheck > (userLimit + restrictedPrepayPeriod)) {
                        ele['enableDisc'] = false;
                    }
                } else {
                    if (!ele.Selected && ele.ApplyDiscAutomatically) {
                        ele.Selected = true;
                        ele['enableDisc'] = false;
                    }
                }
                if (ele.AllowToOverrideDisc) {
                    ele['enableDisc'] = true;
                }
            }
        });
        this.categorizeDiscounts();
    }

    savePromo() {
        this.setUpdateFlagForChangedDiscounts();
        this.emitDiscountList.emit(this.discountModalList);
        if (this.pricingPromotionPopup) {
            this.pricingPromotionPopup.hide();
        }
    }

    onCancelPromo() {
        if (this.pricingPromotionPopup) {
            this.pricingPromotionPopup.hide();
        }
        this.emitCancelDiscount.emit(true);
    }

    isPricingSaveDisabled() {
        if (!this.discountModalList || !this.discountModalList.length) {
            return true;
        }
        this.modifiedRecordsWithoutNotes = this.getChangedDiscountsWithoutNotes();
        if (this.modifiedRecordsWithoutNotes.length > 0) {
            return true;
        }
        const unchangedDiscounts = this.getUnchangedDiscounts();
        if (unchangedDiscounts.length === this.discountModalList.length) {
            return true;
        }
        return false;
    }

    getChangedDiscountsWithoutNotes() {
        return this.discountModalList.filter(item => {
            let obj = this.initialDiscountsList.find(ele => ele.DiscountId == item.DiscountId);
            const itemChanged = (
                item.Selected !== obj.Selected ||
                this.commotMethodService.getDatePartFromAngularDateTime(item.PeriodStartDateTime) !== this.commotMethodService.getDatePartFromAngularDateTime(obj.PeriodStartDateTime) ||
                this.commotMethodService.getDatePartFromAngularDateTime(item.StopDate) !== this.commotMethodService.getDatePartFromAngularDateTime(obj.StopDate) ||
                item.DiscountValue !== obj.DiscountValue ||
                item.NumberOfPeriods !== obj.NumberOfPeriods
            );
            const hasNoNotes = !item.Notes || item.Notes.trim().length === 0;
            return itemChanged && hasNoNotes;
        });
    }

    getUnchangedDiscounts() {
        return this.discountModalList.filter(item => {
            let obj = this.initialDiscountsList.find(ele => ele.DiscountId == item.DiscountId);
            return (
                item.Selected == obj.Selected &&
                this.commotMethodService.getDatePartFromAngularDateTime(item.PeriodStartDateTime) == this.commotMethodService.getDatePartFromAngularDateTime(obj.PeriodStartDateTime) &&
                this.commotMethodService.getDatePartFromAngularDateTime(item.StopDate) == this.commotMethodService.getDatePartFromAngularDateTime(obj.StopDate) &&
                item.DiscountValue == obj.DiscountValue &&
                item.NumberOfPeriods == obj.NumberOfPeriods
            )
        });
    }

    getUpdatedDiscounts(discountData) {
        discountData.forEach(updatedDiscount => {
            const index = this.discountModalList.findIndex(d => d.DiscountId === updatedDiscount.DiscountId);
            if (index !== -1) {
                this.discountModalList[index] = updatedDiscount;
            }
        });
        if (this.moduleType == EModuleType.MakePayment) {
            this.loaderIcon = Promise.resolve(true);
            this.emitDiscountList.emit(this.discountModalList);
        }
    }

    categorizeDiscounts() {
        this.discountsCategorized = true;
        this.discountModalList.forEach((ele) => {
            if (ele.Selected && ele['isActiveOnLoad']) {
                if (ele.DiscountStopped) {
                    ele['Section'] = 3;
                } else {
                    ele['Section'] = 2;
                }
            } else {
                ele['Section'] = 1;
            }
        })
        this.categorizedDiscList = {
            ApplicableDiscounts: this.discountModalList.filter((ele) => ele.Section == 1),
            ActiveDiscounts: this.discountModalList.filter((ele) => ele.Section == 2),
            ActiveAndStoppedDiscounts: this.discountModalList.filter((ele) => ele.Section == 3)
        }
    }

    setUpdateFlagForChangedDiscounts() {
        this.discountModalList.forEach(item => {
            let obj = this.initialDiscountsList.find(ele => ele.DiscountId == item.DiscountId);
            const itemChanged = (
                item.Selected !== obj.Selected ||
                this.commotMethodService.getDatePartFromAngularDateTime(item.PeriodStartDateTime) !== this.commotMethodService.getDatePartFromAngularDateTime(obj.PeriodStartDateTime) ||
                this.commotMethodService.getDatePartFromAngularDateTime(item.StopDate) !== this.commotMethodService.getDatePartFromAngularDateTime(obj.StopDate) ||
                item.DiscountValue != obj.DiscountValue ||
                item.NumberOfPeriods != obj.NumberOfPeriods ||
                item.Notes.trim() != obj.Notes.trim()
            );
            if (itemChanged) {
                item['updated'] = true;
            }
        });
    }
}
